import React from 'react';

import { FormHelperText } from '@mui/material';

import { Field } from '@hrlogics/react-components/form';

import { SelectField } from 'src/components/finalForm';
import { VerificationRequestCreateFormFields } from 'src/constants/verificationRequest';
import type { SelectFieldOption } from 'src/types/components';

type VerificationRequestCreateFormVerificationReportTypeBasicFieldProps = {
  options: SelectFieldOption[];
  multiple?: boolean;
  disabled?: boolean;
  showIncomeDataWarning?: boolean;
};

export const VerificationRequestCreateFormVerificationReportTypeBasicField: React.FC<
  VerificationRequestCreateFormVerificationReportTypeBasicFieldProps
> = ({ options, multiple, disabled, showIncomeDataWarning }) => {
  return (
    <React.Fragment>
      <Field
        name={VerificationRequestCreateFormFields.verificationReportType}
        component={SelectField}
        label="Verification Report type"
        options={options}
        multiple={multiple}
        fullWidth
        required
        disabled={disabled}
      />
      {showIncomeDataWarning && (
        <FormHelperText error>
          There is no income data provided for this employee. Verification of Income is not
          available.
        </FormHelperText>
      )}
    </React.Fragment>
  );
};
